/**
 * HIZLI GÖNDERİM ROZETİ
 *
 * İŞ KURALI: Demontha her üründen sipariş alır ve varsayılan teslim süresi
 * 10 iş günüdür. Stoğa üretilen ürünler (`products.stockPolicy === "madeToStock"`)
 * ise 1 iş gününde çıkar — Trendyol'da yalnızca bunlar satılır, çünkü Trendyol
 * üç günden fazla beklemez.
 *
 * Bu bilgi yalnızca ürün kartında duruyordu; siparişte hiç görünmüyordu. Atölye
 * hangi siparişin aynı gün hazırlanması gerektiğini ekrandan göremiyordu.
 * Rozet tek kaynaktan gelir ki sipariş, sipariş listesi ve üretim ekranı aynı
 * şeyi aynı biçimde göstersin.
 *
 * Sipariş seviyesindeki `fastShipping` bayrağı sunucuda yazılır: kalemlerin
 * HEPSİ stoktan çıkıyorsa sipariş hızlı gönderim kapsamındadır.
 *
 * ★ KURAL DEĞİŞTİ, BU AÇIKLAMA ESKİ KURALI ANLATIYORDU ("biri bile"). Sipariş
 * bütün olarak sevk edilir ve teslim süresi EN YAVAŞ kalem kadardır: 4 kalemin
 * 3'ü stokta, 1'i üretilecekse sipariş 1 iş gününde çıkmaz. Kod üç yazan yolda
 * da düzeltildi (`shopify/handlers/orders.ts`, `orders/manual.ts`,
 * `trendyol/sync.ts`); açıklamanın eski kuralda kalması, bir sonraki okuyanı
 * "kod yanlış" sanıp geri almaya davet ederdi.
 */
export function FastShippingBadge({
  fastShipping,
  size = "sm",
}: {
  fastShipping?: boolean | null;
  size?: "sm" | "md";
}) {
  if (fastShipping !== true) return null;
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 rounded-full border border-green-300 bg-green-50 font-medium text-green-800 ${
        size === "md" ? "px-2.5 py-1 text-sm" : "px-2 py-0.5 text-xs"
      }`}
      title="Stoktan çıkar — 1 iş gününde gönderilir"
    >
      <svg
        viewBox="0 0 20 20"
        aria-hidden="true"
        className={size === "md" ? "h-4 w-4" : "h-3 w-3"}
        fill="currentColor"
      >
        <path d="M11.3 1.05 4 11h4.4l-.7 7.95L15 9h-4.4l.7-7.95Z" />
      </svg>
      Hızlı gönderim
    </span>
  );
}
